<script setup>
import { ref } from 'vue'
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  list: {
    type: Array,
    required: true
  }
})
const isExpanded = ref(false)
const maxContents = props.list.length
const isSmallScreen = ref(false)
const buttonRef = ref(null)

const toggleVisibility = async () => {
  isExpanded.value = !isExpanded.value
  if (!isExpanded.value) {
    await nextTick() // DOMの更新を待つ
    if (buttonRef.value) {
      buttonRef.value.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}

const handleResize = () => {
  if (typeof window !== 'undefined') {
    const wasSmall = isSmallScreen.value
    isSmallScreen.value = window.innerWidth < 830
    if (wasSmall !== isSmallScreen.value) {
      if (!isSmallScreen.value) {
        isExpanded.value = true
      } else {
        isExpanded.value = false
      }
    }
  }
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', handleResize)
    handleResize()
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', handleResize)
  }
})
</script>

<template>
  <section
    class="livecamList"
    :class="{ collapsed: !isExpanded }"
  >
    <SectionTitle title="ライブカメラ一覧" />
    <ul class="content">
      <li
        v-for="content in list"
        :key="content.id"
      >
        <LivecamBlock
          :text="content.name"
          :link="content.link"
          :date="content.latest"
          :img="content.image"
        />
      </li>
    </ul>
    <div
      v-if="isSmallScreen && maxContents > 6"
      ref="buttonRef"
      class="button sp"
    >
      <CommonMoreButton
        :text="isExpanded ? '一部を隠す' : `全${maxContents}件を表示する`"
        :direction="isExpanded ? 'top' : 'bottom'"
        col="white"
        link="###"
        @click.prevent="toggleVisibility"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.livecamList {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, calc((100% - 10px) / 2));
    gap: 10px;
  }
  &.collapsed .content {
    max-height: calc(((50svw - 25px) * 3 / 4 + 48px) * 3 + 20px);
    overflow: hidden;
  }
  .button {
    display: flex;
    justify-content: center;
  }
}
@media screen and (min-width: 830px) {
  .livecamList {
    .content {
      grid-template-columns: repeat(4, calc((100% - 30px) / 4));
      max-height: none;
    }
  }
}
</style>
